<template>
  <div class="marketing-fellow" :style="customStyle" v-if="fellowInfo">
    <div class="marketing-fellow-head">
      蔚来的每一位用户都会拥有自己的专属Fellow，负责您的购车、用车和车生活。
    </div>
    <div class="marketing-fellow-content">
      <img class="fellow-avatar" :src="fellowInfo.headImage || 'https://cdn-app.nio.com/MER/2019/9/25/412ad1cd-7fb1-468c-8e17-62e71970b1a6_imageslim.png'"/>
      <div class="fellow-info">
        <div class="fellow-name">
          <span>{{fellowInfo.name || "蔚来顾问"}}</span>
          <img
            class="icon-nio"
            src="https://cdn-app.nio.com/MER/2019/9/25/dbcb530c-0f9f-45fa-afd3-c92c64a565aa_imageslim.png"
          />
        </div>
        <span class="fellow-level">蔚来顾问</span>
      </div>
      <a :href="`tel:${fellowInfo.mobile}`" @click="fellowCall">
        <img
          class="fellow-call"
          src="https://cdn-app.nio.com/MER/2019/11/8/bc0bb994-b513-43ff-8e24-a6c28f73359f_imageslim.png"
        />
      </a>
    </div>
  </div>
</template>

<script>
export default {
    name: 'marketing-fellow',
    componentName: 'marketingFellow',
    props: {
        customStyle: String,
        userId: String,
        trackEvent: Function,
        trackSelectAction: Function,
        fellowInfo: Object
    },
    data() {
        return {
            observer: null,
            exposeTimer: {}
        };
    },
    watch: {
        fellowInfo() {
            if (this.observer) return;
            this.$nextTick(() => {
                this.addObserver();
            });
        }
    },
    beforeDestroy() {
        if (this.observer) {
            this.observer.unobserve(this.$el);
        }
    },
    methods: {
        fellowCall() {
            console.log('fellowCall');
            if (this.trackEvent) {
                this.trackEvent();
            }
            if (this.trackSelectAction) {
                this.trackSelectAction();
            }
        },
        addObserver() {
            this.observer = new IntersectionObserver(this.trackExposeCallBack, {
                rootMargin: '0px',
                threshold: 0.5
            });
            this.observer.observe(this.$el);
        },
        trackExposeCallBack(val) {
            if (!val[0]) return;
            if (val[0].isIntersecting) {
                this.exposeTimer = setTimeout(() => {
                    this.trackExposeAction();
                }, 1000);
            } else {
                clearTimeout(this.exposeTimer);
            }
        },
        trackExposeAction() {
            this.$emit('trackExposeAction', {
                fellow_emp_domain: this.fellowInfo.fellowEmpDomain
            });
        }
    }
};
</script>

<style lang="less" scoped>
.marketing-fellow {
  margin: 20px 25px;
  background: #FFFFFF;
  box-shadow: 0px 3px 14px 0px rgba(60, 69, 90, 0.15);
  border-radius: 2px;
}

.marketing-fellow-head {
  position: relative;
  padding: 20px 15px;
  margin-bottom: -5px;
  font-size: 14px;
  color: #00263C;
  border-bottom: 1px solid #F0F1F2;
}

.marketing-fellow-head::before {
  content: ' ';
  position: absolute;
  top: 100%;
  left: 25px;
  border-width: 10px;
  border-color: #F0F1F2 transparent transparent transparent;
  border-style: solid;
}

.marketing-fellow-head::after {
  content: ' ';
  position: absolute;
  top: 100%;
  left: 26px;
  border-width: 9px;
  border-color: #FFFFFF transparent transparent transparent;
  border-style: solid;
}

.marketing-fellow-content {
  display: flex;
  padding: 20px 15px;
}

.fellow-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.fellow-avatar {
  width: 40px;
  height: 40px;
  border-radius: 20px;
}

.fellow-call {
  width: 40px;
  height: 40px;
}

.icon-nio {
  width: 20px;
  height: 10px;
  margin-left: 5px;
}

.fellow-name {
  font-size: 16px;
  color: #363C54;
  margin-left: 10px;
  line-height: 22px;
}

.fellow-level {
  font-size: 12px;
  color: #696D7F;
  margin-left: 10px;
  line-height: 18px;
}

</style>




// WEBPACK FOOTER //
// src/views/marketing/components/fellow.vue